import React from 'react';
import RoutePermissionGuard from './RoutePermissionGuard';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission: string;
  loadingFallback?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredPermission, loadingFallback }) => {
  return (
    <RoutePermissionGuard requiredPermission={requiredPermission} loadingFallback={loadingFallback}>
      {children}
    </RoutePermissionGuard>
  );
};


export default ProtectedRoute;
